const SourceTypes = {
  Default: 0,
  Kiosk: 1,
  CurbSide: 5,
  orderPay: 3,
  Online: 6,
  WalkUp: 7,
  PickUp: 6,
  TakeOut: 7,
  TextToPay: 8,
  CallIn: 8,
  ScanToPay: 9,
};

export default SourceTypes;
